export * from './product.model';
export * from './product.service';
export * from './product-form.service';
export * from './product-filter.pipe';


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/shared/index.ts